import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/page";
import ComparisonArticle from "@/pages/articles/comparison/page";
import ShoesGuideArticle from "@/pages/articles/shoes-guide/page";
import SafetyGuideArticle from "@/pages/articles/safety-guide/page";
import BeginnerGuideArticle from "@/pages/articles/beginner-guide/page";
import TipsTricksArticle from "@/pages/articles/tips-tricks/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-ultimate-guide-2026",
    element: <ArticleGuide />,
  },
  {
    path: "/kakobuy-vs-cssbuy-vs-superbuy-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "/kakobuy-shoes-spreadsheet-guide",
    element: <ShoesGuideArticle />,
  },
  {
    path: "/kakobuy-spreadsheet-safety-buying-guide",
    element: <SafetyGuideArticle />,
  },
  {
    path: "/kakobuy-spreadsheet-beginner-guide",
    element: <BeginnerGuideArticle />,
  },
  {
    path: "/kakobuy-spreadsheet-tips-and-tricks",
    element: <TipsTricksArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;